import {
  createUpdateInfiniteDataRecipe,
  createUpdateMultipleItemsRecipe,
} from '@autone/utils';

import { type TransformedAssortmentSkuLocationsResponse } from '../schemas/get-assortment-sku-locations.schema';
import { type EditAssortmentProductLocationRequest } from '../types';

type EditProductLocationRequestBody =
  EditAssortmentProductLocationRequest['body'];

export const createUpdateProductLocationSkusRecipe = ({
  assortment_update: { new_value },
}: EditProductLocationRequestBody) =>
  createUpdateInfiniteDataRecipe(
    createUpdateMultipleItemsRecipe<TransformedAssortmentSkuLocationsResponse>({
      predicate: () => true,
      updateRecipe: (item) => {
        item.is_assorted.value = new_value;
        item.is_managed_by_user = true;
      },
    }),
  );
